export enum LoaderType {
  blocking,
  nonBlocking,
  nonBlockingModal,
}
